import { createContext } from "react"

type LikeContextProps = {
  liked: boolean
  likeCount: number
  onLike: () => void
}

export const LikeContext = createContext({} as LikeContextProps)
